import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import ProductSubCategoryList from './pages/ProductSubCategoryList';
import ShopCart from './pages/ShopCart';
import ShopCheckout from './pages/ShopCheckout';
import Layout from './components/Layout';
import Login from './Account/login';
import RegisterUser from './Account/register-user';
import MyAccount from './Account/my-account';
import VerifyOtp from './Account/verify-otp';
import ForgotPassword from './Account/forgot-password';
import ResetPassword from './Account/reset-password';

const ProtectedAccountRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop-cart" element={<ShopCart />} />
              <Route
                path="/shop-checkout"
                element={(
                  <ProtectedAccountRoute>
                    <ShopCheckout />
                  </ProtectedAccountRoute>
                )}
              />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<RegisterUser />} />
              <Route path="/verify-otp" element={<VerifyOtp />} />
              <Route path="/password-reset" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route
                path="/my-account"
                element={(
                  <ProtectedAccountRoute>
                    <MyAccount />
                  </ProtectedAccountRoute>
                )}
              />
              <Route
                path="/account"
                element={(
                  <ProtectedAccountRoute>
                    <MyAccount />
                  </ProtectedAccountRoute>
                )}
              />
              <Route path="/product-detail/:productId" element={<ProductDetail />} />
              <Route path="/product-sub-category/:slug" element={<ProductSubCategoryList />} />
            </Route>
            <Route path="/product/:slug" element={<Navigate to="/product-detail/1" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
